import { ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-panel-content',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-panel__content{display:block;padding:20px;flex:1}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentComponent implements OnInit {
  readonly PANEL_CONTENT_CLASS = 'mcrai-panel__content';

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef
  ) { }

  ngOnInit() {
    this._renderer
      .addClass(this._elRef.nativeElement, this.PANEL_CONTENT_CLASS);
  }

}
